'use strict';

const _ = require('underscore');
const Base = require('components/Platform/PlatformCardExperience/Steps/BaseAnimation/BaseAnimation');
const Constants = require('constants/Constants');
const scrollLock = require('scroll-lock');

require('./Final.less');

const Selectors = {
    el: '.PlatformCardExperienceFinal',
    clockIconWrapper: '.Clock-iconWrapper',
    clockIcon: '.Clock-icon',
    clockIconsWrapper: '.Clock-icons'
};

const BindFunctions = [
    'onTriggerResize',
    'resetState',
    'onInActive',
    'onActive'
];

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);

        _.bindAll(this, BindFunctions);

        this.msAnimation = 1000;
        this.msReal = 2450;

        this.counter = 0;
        this.isActive = false;
        this.animationTimeout = null;

        this.$clockIcon = this.$(Selectors.clockIcon);
        this.$clockIconsWrapper = this.$(Selectors.clockIconsWrapper);

        app.vent.on('platform-final-resize', this.onTriggerResize);
    },

    onTriggerResize: function (sectionsResizes, offsetWrapper) {
        let offsetTop = 0;
        const offsetIconsWrapper = this.$clockIconsWrapper[0].getBoundingClientRect();
        const offsetLeft = Math.min((offsetWrapper.left - offsetIconsWrapper.left), 0);

        this.$clockIcon.each((id, icon) => {
            const $icon = $(icon);

            if (id !== 0) {
                offsetTop += sectionsResizes[id - 1].minHeight;
            }

            $icon.css('transform', 'translate3d(' + offsetLeft + 'px,' + offsetTop + 'px,0)');
        });

        scrollLock.enablePageScroll();
    },

    resetState: function () {
        if (this.animationTimeout) {
            clearTimeout(this.animationTimeout);
        }

        this.$el.removeClass('Backwards');
        this.$el.removeClass('isAnimation');
    },

    onInActive: function () {
        if (!this.isActive) {
            return;
        }

        scrollLock.setFillGapMethod('max-width');
        scrollLock.disablePageScroll();

        clearInterval(this.interval);
        this.$el.removeClass(Constants.cssClasses.isAnimation);
        this.$el.removeClass(Constants.cssClasses.isActive);

        this.counter = 0;
        this.isActive = false;

        setTimeout(() => {
            scrollLock.enablePageScroll();
        }, 1000);
    },

    onActive: function () {
        if (this.isActive) {
            return;
        }

        scrollLock.setFillGapMethod('max-width');
        scrollLock.disablePageScroll();

        this.$el.addClass(Constants.cssClasses.isActive);

        this.animationTimeout = setTimeout(() => {
            this.$el.addClass(Constants.cssClasses.isAnimation);
        }, 1000);

        let timersEl = document.querySelectorAll('.js-FinalTimeValue');

        this.interval = setInterval(() => {
            const clayMS = this.counter * (this.msReal / this.msAnimation);

            let seconds = Math.round(clayMS / 60);
            let miliseconds = Math.round(clayMS % 60);

            const fullTime = seconds * 1000 + miliseconds * 10;

            miliseconds = miliseconds < 10 ? '0' + miliseconds : miliseconds;

            [...timersEl].forEach((timerEl, index) => {
                timerEl.innerHTML = (index === 0) ? `0${seconds}.${miliseconds}` : `${seconds}.${miliseconds}`;
            });

            this.counter++;

            if (fullTime >= this.msReal) {
                clearInterval(this.interval);

                scrollLock.enablePageScroll();
            }
        }, (1000 / 30));

        this.isActive = true;
    }
});
